import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Global scroll handler.
 * - When the route has a hash (e.g. /#stories), scroll that section into view,
 *   retrying briefly so it also works when the target section renders late.
 * - Otherwise, jump back to the top of the page on every navigation.
 */
export default function ScrollToTop() {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      let attempts = 0;
      const interval = window.setInterval(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          window.clearInterval(interval);
        } else if (attempts >= 12) {
          window.clearInterval(interval);
        }
        attempts += 1;
      }, 100);

      return () => window.clearInterval(interval);
    }

    window.scrollTo({ top: 0, left: 0 });
    return undefined;
  }, [pathname, hash, key]);

  return null;
}